
export function getDeviceInfo() {
    const info = {
        platform: navigator.platform || null,
        userAgent: navigator.userAgent || null,
        isMobile: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent),
        uaPlatform: null
    };

    if (navigator.userAgentData) {
        info.uaBrands = navigator.userAgentData.brands || null;
        info.uaMobile = navigator.userAgentData.mobile;
        info.uaPlatform = navigator.userAgentData.platform;
    }

    return info;
}